(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/models/forecastresult.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/models/forecastresult.js'); 'use strict';

svs.sport.result_boxes.models.ForecastResult = Backbone.Model.extend({
  defaults: {
    winAmount: 0,
    numCorrect: 0,
    hasWon: false,
    drawState: 'Closed',
    productName: '',
    wins: [],
    payouts: []
  },
  newValues: {},
  animateIncrease: null,

  initialize: function() {
    this.listenTo(this.get('model'), 'change', this.handleChange);
  },

  handleChange: function(newData) {
    if (newData.get('hasWon') !== this.get('hasWon')) {
      this.handleHasWonChange(newData);
    }

    if (newData.get('winAmount') !== this.get('winAmount')) {
      this.handleWinAmountChange(newData);
    }

    if (newData.get('numCorrect') !== this.get('numCorrect')) {
      this.animateIncrease = null;
      this.handleNumCorrectChange(newData);
    }

    if (newData.get('payouts') !== this.get('payouts')) {
      this.handlePayoutsChange(newData);
    }

    this.handleWinChange(newData);
    this.set(this.newValues);
  },

  handleWinChange: function(newData) {
    this.newValues.wins = newData.get('wins');
  },

  handleWinAmountChange: function(newData) {
    this.newValues.winAmount = newData.get('winAmount');
  },

  handleHasWonChange: function(newData) {
    this.newValues.hasWon = newData.get('hasWon');
  },

  handleNumCorrectChange: function(newData) {
    if (newData.get('hasWon')) {
      if (newData.get('numCorrect') > this.get('numCorrect')) {
        this.animateIncrease = true;
      } else if (newData.get('numCorrect') < this.get('numCorrect')) {
        this.animateIncrease = false;
      }
    }

    this.newValues.numCorrect = newData.get('numCorrect');
  },

  handlePayoutsChange: function(newData) {
    this.newValues.payouts = newData.get('payouts');
  }
});

 })(window);